import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
  Params,
} from '@angular/router';

/**
 * Recrea el componente de las rutas marcadas con
 * `data: { recrearAlCambiarId: true }` cuando solo cambian sus parámetros
 * (p. ej. `/orden-compra/10` → `/orden-compra/20`).
 *
 * Esos detalles leen el id una sola vez de `route.snapshot`; si Angular
 * reutilizara el componente, la URL mostraría un registro y la pantalla otro.
 * El resto de rutas conserva el comportamiento por defecto.
 */
@Injectable()
export class RecrearAlCambiarIdStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    const config = future.routeConfig;
    if (
      config &&
      config === curr.routeConfig &&
      config.data?.['recrearAlCambiarId'] === true &&
      !mismosParametros(future.params, curr.params)
    ) {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}

function mismosParametros(a: Params, b: Params): boolean {
  const claves = Object.keys(a);
  return (
    claves.length === Object.keys(b).length &&
    claves.every((k) => a[k] === b[k])
  );
}
